import React from 'react';

import paths from './paths';
import PersonalDetailsContainer from './components/PersonalDetails';
import { Orders } from './components/Orders';
import OrderDetailContainer from './components/OrderDetail';
import AddressesContainer from './components/Addresses';
import OrderTracking from './components/OrderTracking';
import { OrderDetailsOffLine } from './components/OrderDetailsOffLine';
import { Returns } from './components/Returns';

export default [
  {
    component: <PersonalDetailsContainer />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.INFO}`,
  },
  {
    component: <Orders />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.ORDERS}`,
  },
  {
    component: <OrderDetailsOffLine />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.ORDERS_OFFLINE}/:ticketId/:ticketDate`,
  },
  {
    component: <OrderDetailContainer />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.ORDERS}/:uid`,
  },
  {
    component: <AddressesContainer />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.ADDRESSES}`,
  },
  {
    component: <OrderTracking />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.TRACKING}/:uid`,
  },
  {
    component: <Returns />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.RETURNS}`,
  },
  {
    component: <Returns isOnline />,
    exact: true,
    path: `${paths.ACCOUNT}${paths.ONLINE_RETURNS}`,
  },
];
